import { StateCreator } from "zustand";
import { TICKER_INTERVAL_MS } from "@/lib/const";

export interface TickerSlice {
  ticker: number;
  intervalId?: NodeJS.Timeout;
  startTicker: () => void;
  stopTicker: () => void;
  resetTicker: () => void;
  tickerState: "running" | "stopped";
}

const initialSlice: Omit<
  TickerSlice,
  "startTicker" | "stopTicker" | "resetTicker"
> = {
  ticker: 0,
  tickerState: "stopped",
};

export const createTickerSlice: StateCreator<
  TickerSlice,
  [],
  [],
  TickerSlice
> = (set, get) => ({
  ...initialSlice,
  startTicker: () => {
    const currentState = get();
    if (currentState.tickerState === "running") return;

    if (currentState.intervalId) {
      clearInterval(currentState.intervalId);
    }

    set({ tickerState: "running" });
    const interval = setInterval(() => {
      set((state) => ({ ticker: state.ticker + 1 }));
    }, TICKER_INTERVAL_MS);

    // Store the interval ID to clear it later
    set({ intervalId: interval });
  },
  stopTicker: () => {
    const { intervalId, tickerState } = get();
    if (tickerState === "stopped") return;

    if (intervalId) {
      clearInterval(intervalId);
    }
    set({ tickerState: "stopped", intervalId: undefined });
  },
  resetTicker: () => {
    const { intervalId } = get();

    if (intervalId) {
      clearInterval(intervalId);
    }
    set({ ticker: 0, tickerState: "stopped", intervalId: undefined });
  },
});
